<template>
  <div class="flex flex-col" :style="{ height: 'calc(100vh - 210px)' }" data-private>
    <div class="px-4 flex gap-1 border-b border-gray-200">
      <button
        v-for="t in subTabs" :key="t.key"
        @click="subTab = t.key"
        class="text-xs px-3 py-2 -mb-px border-b-2 transition-colors"
        :class="subTab === t.key
          ? 'border-primary-500 text-gray-900 font-medium'
          : 'border-transparent text-gray-500 hover:text-gray-700'"
      >{{ t.label }}</button>
    </div>

    <div class="flex-1 min-h-0 overflow-auto">
      <Clinical_Results_List v-if="subTab === 'clinical-results'" />
      <Quality_ECQMFacts v-else-if="subTab === 'ecqm-facts'" />
      <Quality_AgenticParse v-else-if="subTab === 'agentic-parse'" />
    </div>
  </div>
</template>

<script>
import Clinical_Results_List from '@/components/Quality/Clinical_Results_List.vue';
import Quality_ECQMFacts from '@/components/Quality/Quality_ECQMFacts.vue';
import Quality_AgenticParse from '@/components/Quality/Quality_AgenticParse.vue';

export default {
  name: 'Quality_ExtractedData',
  components: {
    Clinical_Results_List,
    Quality_ECQMFacts,
    Quality_AgenticParse,
  },
  data() {
    return {
      subTab: 'clinical-results',
      subTabs: [
        { key: 'clinical-results', label: 'Clinical Results' },
        { key: 'ecqm-facts', label: 'eCQM Facts' },
        { key: 'agentic-parse', label: 'EHR Agentic Parse' },
      ],
    };
  },
};
</script>
